<template>
  <CritereRechercheDossier ref="critereRechercheDossier" @rechercher="rechercher" @effacerCriteres="effacerCriteres"
                           :criteresRecherche="rechercheHistorique" :isRecherche="true" @fermer="fermer"/>
  <ResultatDossier :dossiers="dossiers" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>
import CritereRechercheDossier from '../../components/dossier/Liaison/CritereRechercheLiaisonDossier.vue'
import ResultatDossier from '../../components/dossier/Rechercher/ResultatDossier.vue'
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  name: "dossierRechercher",
  components: {
    CritereRechercheDossier,
    ResultatDossier
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;

    this.isRechercheDataLoading = true;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Dossier");
    if (this.rechercheHistorique) {
      this.$store.dispatch('dossier/rechercherDefaut48HeuresAction', this.nature).then((res) => {
        this.$refs.critereRechercheDossier.assignerListe(res.data.entiteDecision);
        this.rechercher(this.rechercheHistorique);
      });
    } else {
      this.nature = Number(this.$route.params.nature);
      this.$store.dispatch('dossier/rechercherDefaut48HeuresNatureAction', this.nature).then((res) => {
        this.assignerResultat(res)
        this.$refs.critereRechercheDossier.assignerListe(res.data.entiteDecision);
        this.isRechercheDataLoading = false;
      });
    }
    this.$store.dispatch('cardex/obtenirRoleSecuriteAjoutDossierAction').then((res) => {
        this.$refs.critereRechercheDossier.assignerListeSecurite(res.data);
    });
  },
  data() {
    return {
      isRechercheDataLoading: false,
      dossiers: [],
      nature: null,
    }
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      periodeLibelles: 'inscription/periodes',
      rechercheHistorique: 'dossier/rechercheHistorique',
    })
  },
  methods: {
    rechercher(critereRechercheDossier) {
      this.isRechercheDataLoading = true;
      this.$store.dispatch('dossier/rechercherAction', critereRechercheDossier).then((res) => {
        this.$store.commit('dossier/AJOUT_RECHERCHE_HISTORIQUE', critereRechercheDossier)
        this.assignerResultat(res)
        this.isRechercheDataLoading = false;
      })
    },
    assignerResultat(res) {
      this.dossiers = res.data.entites;
      this.$root.$refs.messagesComp.messagesList = res.data.messages

    },
		effacerCriteres() {
			this.isRechercheDataLoading = true;		
			this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
			.then((res) => {
				this.assignerResultat(res)
				this.isRechercheDataLoading = false;
			})
		},
    fermer() {
      this.$store.commit('dossier/RESET_TOUT_SAUF_HISTORIQUE');
      this.$root.$refs.breadcrumbComp.menu();
    },
  }
}
</script>